import { ActivityIcon } from './activityIcon';
import { AddIcon } from './addIcon';
import { AddonsIcon } from './addonsIcon';
import { AiSquareIcon } from './aiSquareIcon';
import { AlertIcon } from './alertIcon';
import { AndroidIcon } from './androidIcon';
import { AppleIcon } from './appleIcon';
import { ArchiveIcon } from './archiveIcon';
import { ArrowBottomLeftAngleIcon } from './arrowBottomLeftAngleIcon';
import { ArrowBottomRightAngleIcon } from './arrowBottomRightAngleIcon';
import { ArrowDownIcon } from './arrowDownIcon';
import { ArrowLeftIcon } from './arrowLeftIcon';
import { ArrowRightIcon } from './arrowRightIcon';
import { ArrowTopLeftAngleIcon } from './arrowTopLeftAngleIcon';
import { ArrowTopRightAngleIcon } from './arrowTopRightAngleIcon';
import { ArrowUpIcon } from './arrowUpIcon';
import { AtIcon } from './atIcon';
import { AttachmentIcon } from './attachmentIcon';
import { BarnAIcon } from './barnAIcon';
import { BarnBIcon } from './barnBIcon';
import { BarnCIcon } from './barnCIcon';
import { BoldIcon } from './boldIcon';
import { BookmarkIcon } from './bookmarkIcon';
import { BranDIcon } from './branDIcon';
import { BranEIcon } from './branEIcon';
import { BulletListIcon } from './bulletListIcon';
import { CalendarIcon } from './calendarIcon';
import { CallIcon } from './callIcon';
import { CallEndIcon } from './callEndIcon';
import { CameraIcon } from './cameraIcon';
import { CampaignsIcon } from './campaignsIcon';
import { CheckIcon } from './checkIcon';
import { ChevronDownIcon } from './chevronDownIcon';
import { ChevronLeftIcon } from './chevronLeftIcon';
import { ChevronRightIcon } from './chevronRightIcon';
import { ChevronUpIcon } from './chevronUpIcon';
import { CircleCheckIcon } from './circleCheckIcon';
import { ClockAIcon } from './clockAIcon';
import { ClockBIcon } from './clockBIcon';
import { ClockCIcon } from './clockCIcon';
import { CommentIcon } from './commentIcon';
import { CopyIcon } from './copyIcon';
import { DeleteIcon } from './deleteIcon';
import { DocumentIcon } from './documentIcon';
import { DocumentBIcon } from './documentBIcon';
import { DotIcon } from './dotIcon';
import { DoubleArrowIcon } from './doubleArrowIcon';
import { DownloadIcon } from './downloadIcon';
import { DualIcon } from './dualIcon';
import { EditIcon } from './editIcon';
import { FacebookIcon } from './facebookIcon';
import { FilterIcon } from './filterIcon';
import { FlashIcon } from './flashIcon';
import { GoogleIcon } from './googleIcon';
import { GroupsIcon } from './groupsIcon';
import { HelpIcon } from './helpIcon';
import { HomeIcon } from './homeIcon';
import { ImageIcon } from './imageIcon';
import { ItalicIcon } from './italicIcon';
import { LinkedinIcon } from './linkedinIcon';
import { LabIcon } from './labIcon';
import { LinkIcon } from './linkIcon';
import { LocationIcon } from './locationIcon';
import { LockIcon } from './lockIcon';
import { MailIcon } from './mailIcon';
import { MicrophoneIcon } from './microphoneIcon';
import { MicrophoneMutedIcon } from './microphoneMutedIcon';
import { MicrosoftIcon } from './microsoftIcon';
import { MobileIcon } from './mobileIcon';
import { MoreVerticalIcon } from './moreVerticalIcon';
import { NotScheduledAIcon } from './notScheduledAIcon';
import { NotScheduledBIcon } from './notScheduledBIcon';
import { NotScheduledIcon } from './notScheduledIcon';
import { NoteIcon } from './noteIcon';
import { NotificationIcon } from './notificationIcon';
import { NotificationPlusIcon } from './notificationPlusIcon';
import { OrderedListIcon } from './orderedListIcon';
import { PeopleIcon } from './peopleIcon';
import { PhoneIcon } from './phoneIcon';
import { PhoneCallIcon } from './phoneCallIcon';
import { PinIcon } from './pinIcon';
import { PrintIcon } from './printIcon';
import { ProfileIcon } from './profileIcon';
import { QrIcon } from './qrIcon';
import { RemoveIcon } from './removeIcon';
import { ReplyIcon } from './replyIcon';
import { ResetIcon } from './resetIcon';
import { RoutineIcon } from './routineIcon';
import { SaveIcon } from './saveIcon';
import { SaveAsDraftIcon } from './saveAsDraftIcon';
import { ScheduledIcon } from './scheduledIcon';
import { SearchIcon } from './searchIcon';
import { SettingsIcon } from './settingsIcon';
import { ShareIcon } from './shareIcon';
import { SidechatIcon } from './sidechatIcon';
import { StrikethroughIcon } from './strikethroughIcon';
import { TagIcon } from './tagIcon';
import { TextIcon } from './textIcon';
import { UnderlineIcon } from './underlineIcon';
import { VideoIcon } from './videoIcon';
import { VideoCallIcon } from './videoCallIcon';
import { XIcon } from './xIcon';
import { YoutubeIcon } from './youtubeIcon';

// Icon name mapping for dynamic access
export const iconMap = {
  Activity: ActivityIcon,
  Add: AddIcon,
  Addons: AddonsIcon,
  'AI Square': AiSquareIcon,
  Alert: AlertIcon,
  Android: AndroidIcon,
  Apple: AppleIcon,
  Archive: ArchiveIcon,
  'Arrow Bottom Left Angle': ArrowBottomLeftAngleIcon,
  'Arrow Bottom Right Angle': ArrowBottomRightAngleIcon,
  'Arrow Down': ArrowDownIcon,
  'Arrow Left': ArrowLeftIcon,
  'Arrow Right': ArrowRightIcon,
  'Arrow Top Left Angle': ArrowTopLeftAngleIcon,
  'Arrow Top Right Angle': ArrowTopRightAngleIcon,
  'Arrow Up': ArrowUpIcon,
  At: AtIcon,
  Attachment: AttachmentIcon,
  'Barn A': BarnAIcon,
  'Barn B': BarnBIcon,
  'Barn C': BarnCIcon,
  Bookmark: BookmarkIcon,
  Bold: BoldIcon,
  'Bran D': BranDIcon,
  'Bran E': BranEIcon,
  'Bullet List': BulletListIcon,
  Calendar: CalendarIcon,
  Call: CallIcon,
  CallEnd: CallEndIcon,
  Camera: CameraIcon,
  Campaigns: CampaignsIcon,
  Check: CheckIcon,
  'Chevron Down': ChevronDownIcon,
  'Chevron Left': ChevronLeftIcon,
  'Chevron Right': ChevronRightIcon,
  'Chevron Up': ChevronUpIcon,
  'Circle Check': CircleCheckIcon,
  'Clock A': ClockAIcon,
  'Clock B': ClockBIcon,
  'Clock C': ClockCIcon,
  Comment: CommentIcon,
  Copy: CopyIcon,
  Delete: DeleteIcon,
  Document: DocumentIcon,
  'Document B': DocumentBIcon,
  Dot: DotIcon,
  'Double Arrow': DoubleArrowIcon,
  Download: DownloadIcon,
  Dual: DualIcon,
  Edit: EditIcon,
  Facebook: FacebookIcon,
  Filter: FilterIcon,
  Flash: FlashIcon,
  Google: GoogleIcon,
  Groups: GroupsIcon,
  Help: HelpIcon,
  Home: HomeIcon,
  Image: ImageIcon,
  Italic: ItalicIcon,
  Lab: LabIcon,
  Linkedin: LinkedinIcon,
  Link: LinkIcon,
  Location: LocationIcon,
  Lock: LockIcon,
  Mail: MailIcon,
  Microphone: MicrophoneIcon,
  MicrophoneMuted: MicrophoneMutedIcon,
  Microsoft: MicrosoftIcon,
  Mobile: MobileIcon,
  'More Vertical': MoreVerticalIcon,
  'Not Scheduled': NotScheduledIcon,
  'Not Scheduled A': NotScheduledAIcon,
  'Not Scheduled B': NotScheduledBIcon,
  Note: NoteIcon,
  Notification: NotificationIcon,
  'Notification +': NotificationPlusIcon,
  'Ordered List': OrderedListIcon,
  People: PeopleIcon,
  Phone: PhoneIcon,
  PhoneCall: PhoneCallIcon,
  Pin: PinIcon,
  Print: PrintIcon,
  Profile: ProfileIcon,
  QR: QrIcon,
  Remove: RemoveIcon,
  Reply: ReplyIcon,
  Reset: ResetIcon,
  Routine: RoutineIcon,
  Save: SaveIcon,
  Scheduled: ScheduledIcon,
  Search: SearchIcon,
  Settings: SettingsIcon,
  Share: ShareIcon,
  Sidechat: SidechatIcon,
  Strikethrough: StrikethroughIcon,
  Tag: TagIcon,
  Text: TextIcon,
  Underline: UnderlineIcon,
  Video: VideoIcon,
  VideoCall: VideoCallIcon,
  x: XIcon,
  Youtube: YoutubeIcon,
  'Save as Draft': SaveAsDraftIcon,
};

export type IconName = keyof typeof iconMap;
